import { render, staticRenderFns } from "./sim.vue?vue&type=template&id=6a1971b0&"
import script from "./sim.vue?vue&type=script&lang=js&"
export * from "./sim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports